// eslint-disable-next-line import/prefer-default-export
export const PHONE_MAX_LENGTH = 100;
